import type { EIntegrationTypes, Targeting, TPredicateMode } from '@feathr/blackbox';

export const MAX_GROUP_NUM_SIZE = 10000000;
export const MATCH_ANY_GROUP_ID = -3;

/**
 * Determine the segmented control value based on the current interest targetings.
 * @returns TPredicateMode - determines whether we're in `match_any` or `match_all` mode
 */
export function determineInterestsMatchMode(interestTargetings: Targeting[]): TPredicateMode {
  const groupIds = interestTargetings.map((t) => t.get('group'));
  if (groupIds.length === 0 || groupIds.includes(MATCH_ANY_GROUP_ID)) {
    return 'match_any';
  } else {
    return 'match_all';
  }
}

export function generateUniqueGroupId(): number {
  return Math.floor(Math.random() * MAX_GROUP_NUM_SIZE);
}

export function getGroupIdForInterest(matchMode: TPredicateMode): number {
  if (matchMode === 'match_any') {
    return MATCH_ANY_GROUP_ID;
  } else {
    return generateUniqueGroupId();
  }
}

/**
 * Derives the channels to pass to the interests API from campaign integrations.
 *
 * The API uses AND logic — passing multiple channels returns only interests
 * valid for all of them. When a single channel is selected we filter to that
 * channel. When multiple (or none) are selected we return undefined so the
 * API returns all interests.
 *
 * @param integrations - The campaign's integration types array.
 * @returns A single-element channel string to filter by, or undefined for no filtering.
 */
export function getInterestChannels(
  integrations: EIntegrationTypes[] | undefined,
): string | undefined {
  if (integrations?.length === 1) {
    return integrations[0];
  }
  return undefined;
}
